<template>
  <div>
      <!--side-menu-->
			
			
					<div class="side-menu">
						
						<div class="p-t-55 sidebar-categories">
							<h4 class="mtext-112 cl2 p-b-33">
								Categories
							</h4>

							<ul >
								
								<li class="main-nav-list"  v-for="(category, i) in categoriesList" :key="category" style="cursor:pointer;" @click="collapseItem(i)"><a>{{category}}<span class="number">(77)</span><span class="ml-3"><i class="fa fa-angle-down" aria-hidden="true"></i></span></a>
									<ul  >
										<!-- <li class="main-nav-list child" v-for="(hh, item) in category" :key9="item"><a href="#">{{hh}}<span class="number">(12)</span></a></li> -->
										<!-- <li :style="{display: display}" class="main-nav-list child" v-for="(sub, i)  in category" :key="i"  ><a href="#"  >{{sub}}<span  class="number">(09)</span></a></li> -->
										<!-- <li class="main-nav-list child"><a href="#">Fresh Fish<span class="number">(17)</span></a></li>
										<li class="main-nav-list child"><a href="#">Meat Alternatives<span class="number">(01)</span></a></li>
										<li class="main-nav-list child"><a href="#">Meat<span class="number">(11)</span></a></li> -->
									</ul>
								</li>
								<li class="main-nav-list"><a data-toggle="collapse" href="#beauttyProduct" aria-expanded="false" aria-controls="beauttyProduct">Beauty Products<span class="number">(65)</span><span class="ml-3"><i class="fa fa-angle-down" aria-hidden="true"></i></span></a>
									<ul class="collapse" id="beauttyProduct" data-toggle="collapse" aria-expanded="false" aria-controls="beauttyProduct">
										<li class="main-nav-list child"><a href="#">Frozen Fish<span class="number">(13)</span></a></li>
										<li class="main-nav-list child"><a href="#">Dried Fish<span class="number">(09)</span></a></li>
										<li class="main-nav-list child"><a href="#">Fresh Fish<span class="number">(17)</span></a></li>
										<li class="main-nav-list child"><a href="#">Meat Alternatives<span class="number">(01)</span></a></li>
										<li class="main-nav-list child"><a href="#">Meat<span class="number">(11)</span></a></li>
									</ul>
								</li>
								<li class="main-nav-list"><a data-toggle="collapse" href="#fruitsVegetable" aria-expanded="false" aria-controls="fruitsVegetable">Fruits and Vegetables<span class="number">(53)</span><span class="ml-3"><i class="fa fa-angle-down" aria-hidden="true"></i></span></a>
									<ul class="collapse" id="fruitsVegetable" data-toggle="collapse" aria-expanded="false" aria-controls="fruitsVegetable">
										<li class="main-nav-list child"><a href="#">Frozen Fish<span class="number">(13)</span></a></li>
										<li class="main-nav-list child"><a href="#">Dried Fish<span class="number">(09)</span></a></li>
										<li class="main-nav-list child"><a href="#">Fresh Fish<span class="number">(17)</span></a></li>
										<li class="main-nav-list child"><a href="#">Meat Alternatives<span class="number">(01)</span></a></li>
										<li class="main-nav-list child"><a href="#">Meat<span class="number">(11)</span></a></li>
									</ul>
								</li>
								
								<li class="bor18">
									<a href="#" class="dis-block stext-115 cl6 hov-cl1 trans-04 p-tb-8 p-lr-4">
										Fashion
									</a>
								</li>

								<li class="bor18">
									<a href="#" class="dis-block stext-115 cl6 hov-cl1 trans-04 p-tb-8 p-lr-4">
										Beauty
									</a>
								</li>

								<li class="bor18">
									<a href="#" class="dis-block stext-115 cl6 hov-cl1 trans-04 p-tb-8 p-lr-4">
										Street Style
									</a>
								</li>

								<li class="bor18">
									<a href="#" class="dis-block stext-115 cl6 hov-cl1 trans-04 p-tb-8 p-lr-4">
										Life Style
									</a>
								</li>

								<li class="bor18">
									<a href="#" class="dis-block stext-115 cl6 hov-cl1 trans-04 p-tb-8 p-lr-4">
										DIY & Crafts
									</a>
								</li>
							</ul>
						</div>

						<div class="p-t-65">
							<h4 class="mtext-112 cl2 p-b-33">
								Featured Products
							</h4>

							<ul>
								<li class="flex-w flex-t p-b-30">
									<a href="#" class="wrao-pic-w size-214 hov-ovelay1 m-r-20">
										<img src="images/product-min-01.jpg" alt="PRODUCT">
									</a>

									<div class="size-215 flex-col-t p-t-8">
										<a href="#" class="stext-116 cl8 hov-cl1 trans-04">
											White Shirt With Pleat Detail Back
										</a>

										<span class="stext-116 cl6 p-t-20">
											$19.00
										</span>
									</div>
								</li>

								<li class="flex-w flex-t p-b-30">
									<a href="#" class="wrao-pic-w size-214 hov-ovelay1 m-r-20">
										<img src="images/product-min-02.jpg" alt="PRODUCT">
									</a>

									<div class="size-215 flex-col-t p-t-8">
										<a href="#" class="stext-116 cl8 hov-cl1 trans-04">
											Converse All Star Hi Black Canvas
										</a>

										<span class="stext-116 cl6 p-t-20">
											$39.00
										</span>
									</div>
								</li>

								<li class="flex-w flex-t p-b-30">
									<a href="#" class="wrao-pic-w size-214 hov-ovelay1 m-r-20">
										<img src="images/product-min-03.jpg" alt="PRODUCT">
									</a>

									<div class="size-215 flex-col-t p-t-8">
										<a href="#" class="stext-116 cl8 hov-cl1 trans-04">
											Nixon Porter Leather Watch In Tan
										</a>

										<span class="stext-116 cl6 p-t-20">
											$17.00
										</span>
									</div>
								</li>
							</ul>
						</div>

						<div class="p-t-55 sidebar-filter">
							<h4 class="mtext-112 cl2 p-b-20">
								Brand
							</h4>

							<ul class="common-filter">
								<form action="#">
									<ul>
										<li class="filter-list"><input class="pixel-radio" type="radio" id="apple" name="brand"><label for="apple">Apple<span>(29)</span></label></li>
										<li class="filter-list"><input class="pixel-radio" type="radio" id="asus" name="brand"><label for="asus">Asus<span>(29)</span></label></li>
										<li class="filter-list"><input class="pixel-radio" type="radio" id="gionee" name="brand"><label for="gionee">Gionee<span>(19)</span></label></li>
										<li class="filter-list"><input class="pixel-radio" type="radio" id="micromax" name="brand"><label for="micromax">Micromax<span>(19)</span></label></li>
										<li class="filter-list"><input class="pixel-radio" type="radio" id="samsung" name="brand"><label for="samsung">Samsung<span>(19)</span></label></li>
									</ul>
								</form>
								<li class="p-b-7">
									<a href="#" class="flex-w flex-sb-m stext-115 cl6 hov-cl1 trans-04 p-tb-2">
										<span>
											July 2018
										</span>

										<span>
											(9)
										</span>
									</a>
								</li>

								
							</ul>
						</div>

						<div class="p-t-50">
							<h4 class="mtext-112 cl2 p-b-27">
								Tags
							</h4>

							<div class="flex-w m-r--5">
								<a href="#" class="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5">
									Fashion
								</a>

								<a href="#" class="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5">
									Lifestyle
								</a>

								<a href="#" class="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5">
									Denim
								</a>

								<a href="#" class="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5">
									Streetstyle
								</a>

								<a href="#" class="flex-c-m stext-107 cl6 size-301 bor7 p-lr-15 hov-tag1 trans-04 m-r-5 m-b-5">
									Crafts
								</a>
							</div>
						</div>
					</div>
				
			
  </div>
</template>

<script>
import db from "../../config/FirebaseInit"
import firebase from "firebase/app"
import mobiles from '../../data/mobiles'
import ClothingAccessories from '../../data/ClothingAccessories'
export default {
  name: 'storesidebar',
  data() {
	  return {
		  display: "none",
		  openedItems: {},
		  categoriesList: [],
		  subcategories:this.$route.query.cat,
		  subcat: [],
		  shops: [],
		  products: []
		  
		  
		  
	  }
  },
  computed: {
	  
	//   subcategories:{
	// 	  set: function() {
	// 	  this.subcategories = this.$route.query.cat
	// 	  console.log(this.subcategories + "comp")
	// 	  },
	// 	  get: function() {
	// 		  return this.subcategories
	// 	  }
 	//   }
  },
 // props: ['categoriesList'],
  watch: {
	//   '$route.query.cat': function () {
	// 	  this.subcategories = this.$route.query.cat
	// },
	$route (to, from){
		 this.subcategories = this.$route.query.cat
		 console.log(this.$route.query.cat + "route")
		 console.log(this.subcategories + "route")

		 
    },
      subcategories() {
		  
		  console.log(this.subcategories + "subct")
		   if(this.shops[0].shoptype == 'Fashion'){
			console.log(this.$route.query.cat + "shop")
			
		  this.categoriesList = ClothingAccessories[ this.subcategories]
		  
		  console.log( "rtggg")
      for( i in this.categoriesList){
				  
				    console.log(this.categoriesList[i])
			   }
		  console.log(this.categoriesList)
		  console.log(this.shops)
      }
      if(this.shops[0].shoptype == 'Elec'){
          this.categoriesList = mobiles
      }

	  },
      shops () {
		   console.log(this.subcategories + "subct")
		   if(this.shops[0].shoptype == 'Fashion'){
			console.log(this.$route.query.cat + "shop")
			
		  this.categoriesList = ClothingAccessories[ this.subcategories]
		  
		  console.log( "rtggg")
      for( i in this.categoriesList){
				  
				    console.log(this.categoriesList[i])
			   }
		  console.log(this.categoriesList)
		  console.log(this.shops)
      }
      if(this.shops[0].shoptype == 'Elec'){
          this.categoriesList = mobiles
      }
        
	  },
	  
	  subcat () {
		  
      if(this.shops[0].shoptype == 'Elec'){
          this.subcat = mobiles
      }
	  }
  },

  methods: {
    collapseItem(n) {
		 db.collection("products").where("category", "==", this.categoriesList[i])
		  .where("shopID", "==", this.$route.params.storename)
		.onSnapshot((snapshot) => {
			snapshot.forEach( doc => {
				const data = {
			'id' : doc.id, 
			'name': doc.data().name, 
			'price': doc.data().price,
			'image': doc.data().imageUrl     
			}
			this.products.push(data) 
			console.log(this.products)
			})
		})
    }
  },

  beforeCreate(){
	   console.log("this.shops[0].shoptype")
      db.collection('shops').where('owner', '==', this.$route.params.storename).get()
      .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'shoptype' : doc.data().shoptype
          
        }
        this.shops.push(data)
          console.log(this.shops[0].shoptype)
      })
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/store/StoreSidebar.vue